import axios from "axios";
import { reportingUrl } from "../../Config/Url";

export const reportingServices = {
  getRecapitulationTaxrate,
  getRecapitulationStore,
  getRecapitulationProductGroup,
  getRecapitulationProduct,
  getRecapitulationDocumentType,
  getProductTransactionsCumulative,
  getProductTransactions,
  exportXLSXRecapitulationTaxrate,
  exportXLSXRecapitulationStore,
  exportXLSXRecapitulationProductGroup,
  exportXLSXRecapitulationProduct,
  exportXLSXRecapitulationDocumentType,
  exportXLSXProductTransactionsCumulative,
  exportXLSXProductTransactions,
  getStoreStock,
};

async function getRecapitulationTaxrate({
  tenantId,
  storeTag,
  productGuid,
  productGroups,
  documentTypeId,
  from,
  to,
}) {
  return axios
    .put(`${reportingUrl}/get-recapitulation-taxrate`, {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    })
    .then((res) => res)
    .catch((err) => err);
}
async function getRecapitulationStore({
  tenantId,
  storeTag,
  productGuid,
  productGroups,
  documentTypeId,
  from,
  to,
}) {
  return axios
    .put(`${reportingUrl}/get-recapitulation-store`, {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    })
    .then((res) => res)
    .catch((err) => err);
}
async function getRecapitulationProductGroup({
  tenantId,
  storeTag,
  productGuid,
  productGroups,
  documentTypeId,
  from,
  to,
}) {
  return axios
    .put(`${reportingUrl}/get-recapitulation-productgroup`, {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    })
    .then((res) => res)
    .catch((err) => err);
}
async function getRecapitulationProduct({
  tenantId,
  storeTag,
  productGuid,
  productGroups,
  documentTypeId,
  from,
  to,
}) {
  return axios
    .put(`${reportingUrl}/get-recapitulation-product`, {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    })
    .then((res) => res)
    .catch((err) => err);
}
async function getRecapitulationDocumentType({
  tenantId,
  storeTag,
  productGuid,
  productGroups,
  documentTypeId,
  from,
  to,
}) {
  return axios
    .put(`${reportingUrl}/get-recapitulation-document-type`, {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    })
    .then((res) => res)
    .catch((err) => err);
}
async function getProductTransactionsCumulative({
  tenantId,
  storeTag,
  productGuid,
  productGroups,
  documentTypeId,
  from,
  to,
}) {
  return axios
    .put(`${reportingUrl}/get-product-transactions-cumulative`, {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    })
    .then((res) => res)
    .catch((err) => err);
}
async function getProductTransactions({
  tenantId,
  storeTag,
  productGuid,
  productGroups,
  documentTypeId,
  from,
  to,
}) {
  return axios
    .put(`${reportingUrl}/get-product-transactions`, {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    })
    .then((res) => res)
    .catch((err) => err);
}
async function exportXLSXRecapitulationTaxrate(
  { tenantId, storeTag, productGuid, productGroups, documentTypeId, from, to },
  fileName = "file"
) {
  return axios({
    method: "post",
    url: `${reportingUrl}/get-recapitulation-taxrate-excel`,
    data: {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    },
    responseType: "blob",
  })
    .then((res) => dowlnoadExcel(res, fileName))
    .catch((err) => err);
}
async function exportXLSXRecapitulationStore(
  { tenantId, storeTag, productGuid, productGroups, documentTypeId, from, to },
  fileName = "file"
) {
  return axios({
    method: "post",
    url: `${reportingUrl}/get-recapitulation-store-excel`,
    data: {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    },
    responseType: "blob",
  })
    .then((res) => dowlnoadExcel(res, fileName))
    .catch((err) => err);
}
async function exportXLSXRecapitulationProductGroup(
  { tenantId, storeTag, productGuid, productGroups, documentTypeId, from, to },
  fileName = "file"
) {
  return axios({
    method: "post",
    url: `${reportingUrl}/get-recapitulation-productgroup-excel`,
    data: {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    },
    responseType: "blob",
  })
    .then((res) => dowlnoadExcel(res, fileName))
    .catch((err) => err);
}
async function exportXLSXRecapitulationProduct(
  { tenantId, storeTag, productGuid, productGroups, documentTypeId, from, to },
  fileName = "file"
) {
  return axios({
    method: "post",
    url: `${reportingUrl}/get-recapitulation-product-excel`,
    data: {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    },
    responseType: "blob",
  })
    .then((res) => dowlnoadExcel(res, fileName))
    .catch((err) => err);
}
async function exportXLSXRecapitulationDocumentType(
  { tenantId, storeTag, productGuid, productGroups, documentTypeId, from, to },
  fileName = "file"
) {
  return axios({
    method: "post",
    url: `${reportingUrl}/get-recapitulation-document-type-excel`,
    data: {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    },
    responseType: "blob",
  })
    .then((res) => dowlnoadExcel(res, fileName))
    .catch((err) => err);
}
async function exportXLSXProductTransactionsCumulative(
  { tenantId, storeTag, productGuid, productGroups, documentTypeId, from, to },
  fileName = "file"
) {
  return axios({
    method: "post",
    url: `${reportingUrl}/get-product-transactions-cumulative-excel`,
    data: {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    },
    responseType: "blob",
  })
    .then((res) => dowlnoadExcel(res, fileName))
    .catch((err) => err);
}
async function exportXLSXProductTransactions(
  { tenantId, storeTag, productGuid, productGroups, documentTypeId, from, to },
  fileName = "file"
) {
  return axios({
    method: "post",
    url: `${reportingUrl}/get-product-transactions-excel`,
    data: {
      tenantId,
      storeTag,
      productGuid,
      productGroups,
      documentTypeId,
      from,
      to,
    },
    responseType: "blob",
  })
    .then((res) => dowlnoadExcel(res, fileName))
    .catch((err) => err);
}
const dowlnoadExcel = (res, fileName) => {
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName + ".xlsx");
  document.body.appendChild(link);
  link.click();
};

async function getStoreStock({ storeId, from, to }) {
  return axios
    .put(`${reportingUrl}/stock`, {
      storeId,
      from,
      to,
    })
    .then((res) => res)
    .catch((err) => err);
}
